export enum Scopes {
  UpdateSchedule = 'update:schedule'
}
